module.exports = __webpack_public_path__ + "static/img/news1.fae0162.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/news1.jpg
// module id = 6uWW
// module chunks = 0